import { FC } from 'react';
import Logo from '@/assets/icons/logotipo_blanco.svg';
import { Texto, Divisor, PilaH, PilaV, Imagen, Boton } from '../atomos';
import EnlaceIcono from '../atomos/EnlaceIcono';
import { Facebook, Instagram, Linkedin, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import { AVISOS, FACTORING } from '@/routes/AppRoutes';
import { useToast } from '@chakra-ui/react';

const PieDePagina: FC = () => {
  const toast = useToast();

  const copiarMailContacto = () => {
    if (navigator?.clipboard) {
      navigator.clipboard.writeText('contacto@temba.cl');
      toast({
        title: 'Mail de contacto copiado',
        status: 'success',
        isClosable: true,
        duration: 2000,
        position: 'top',
      });
    }
  };

  return (
    <PilaV
      as='footer'
      bg='#000065'
      color='white'
      gap='4'
      pt='8'
      pb='4'
      h='max-content'
      w='full'
      position={'relative'}
    >
      {/* Logo */}
      <PilaV spacing={4} position={'relative'} w={'full'}>
        <PilaV>
          <Imagen src={Logo} alt='footer-logo' h={'7rem'} />
          <PilaH alignItems={'center'} spacing={2}>
            <Mail size={20} />
            <Boton
              variant='link'
              colorScheme='white'
              onClick={copiarMailContacto}
              fontWeight={'normal'}
            >
              contacto@temba.cl
            </Boton>
          </PilaH>
        </PilaV>
        <PilaH spacing={4} fontWeight={'normal'}>
          <Link to={FACTORING.LANDING}>
            <Texto>Inicio</Texto>
          </Link>
          <Texto>·</Texto>
          <Link to={AVISOS.POLITICAS}>
            <Texto>Política de Privacidad</Texto>
          </Link>
          <Texto>·</Texto>
          <Link to={AVISOS.TERMINOS_USO}>
            <Texto>Términos de uso</Texto>
          </Link>
          <Texto>·</Texto>
          <Link to={AVISOS.TERMINOS}>
            <Texto>Términos y condiciones</Texto>
          </Link>
        </PilaH>

        <Texto position={'absolute'} right={2} bottom={-3} color={'#FFFFFF80'}>
          v1.0.21
        </Texto>
      </PilaV>

      <Divisor fill={'white'} />

      <PilaH justifyContent={'space-between'} w={'full'} px='6'>
        <Texto color={'white'} data-testid='copyright'>
          © {new Date().getFullYear()} Temba. Todos los Derechos reservados
        </Texto>
        <PilaH>
          <PilaH spacing={4}>
            {/* Redes sociales*/}
            <EnlaceIcono
              isExternal
              href='https://www.linkedin.com/company/temba-cl/'
            >
              <Linkedin strokeWidth={1.5} size={24} />
            </EnlaceIcono>
            <EnlaceIcono isExternal href='https://www.instagram.com/temba.cl'>
              <Instagram strokeWidth={1.5} size={24} />
            </EnlaceIcono>
            <EnlaceIcono isExternal href='https://www.facebook.com/temba.cl'>
              <Facebook strokeWidth={1.5} size={24} />
            </EnlaceIcono>
          </PilaH>
        </PilaH>
      </PilaH>
    </PilaV>
  );
};

export default PieDePagina;
